import { useCallback } from "react";

import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router";
import { useShallow } from "zustand/react/shallow";

import { CommonListType } from "__graphql__/types";
import { CollaborativeInboundUpdateState } from "analytics/events";
import { routes } from "config/routes";
import { CtaModal } from "ui/CtaModal";
import { SuccessIcon } from "ui/Icons/Icons";
import { BodyM } from "ui/Typography/Typography";

import { useInboundEventTracker } from "../hooks/useInboundEventTracker/useInboundEventTracker";
import { InboundingType } from "../stores/inboundStore/types";
import { useInboundStore } from "../stores/inboundStore/useInboundStore";

export function ClaimedlistNotFoundWarningModal() {
  const intl = useIntl();
  const navigate = useNavigate();
  const {
    droppingListId,
    deliverySSCC,
    deliveryType,
    creatorId,
    orderId,
    droppingListType,
    setInboundUIState,
  } = useInboundStore(
    useShallow((state) => ({
      droppingListId: state.droppingListId,
      deliverySSCC: state.deliverySSCC,
      deliveryType: state.deliveryType,
      droppingListType: state.droppingListType,
      creatorId: state.creatorId,
      orderId: state.orderId,
      setInboundUIState: state.setInboundUIState,
    })),
  );
  const { sendInboundStateUpdate } = useInboundEventTracker();
  const isCancelledOrder = droppingListType === CommonListType.list_type_cancelled_order;

  const handleOnclick = useCallback(() => {
    setInboundUIState({ isClaimedListNotFoundWarningModalVisible: false });
    sendInboundStateUpdate({
      state: CollaborativeInboundUpdateState.DroppingListFinished,
      droppingListId,
      sscc: deliverySSCC,
      inboundingType: isCancelledOrder ? InboundingType.ReinboundedOrder : deliveryType,
      creatorId,
      orderId,
    });
    navigate(routes.inbound.root);
  }, [
    creatorId,
    deliverySSCC,
    deliveryType,
    droppingListId,
    isCancelledOrder,
    navigate,
    orderId,
    sendInboundStateUpdate,
    setInboundUIState,
  ]);
  return (
    <CtaModal
      isOpen
      onClose={() => {}}
      hideCloseButton
      onClickCta={handleOnclick}
      headerIcon={<SuccessIcon boxSize="80px" />}
      title={intl.formatMessage({
        id: "flows.inbound.components.claimedlist-not-found-warning-modal.title",
      })}
      ctaLabel={intl.formatMessage({
        id: "flows.inbound.components.claimedlist-not-found-warning-modal.cta",
      })}
      body={
        <BodyM textAlign="center">
          <FormattedMessage id="flows.inbound.components.claimedlist-not-found-warning-modal.body" />
        </BodyM>
      }
    />
  );
}
